import { matchPath } from 'react-router'
import { GetLocalStorage, getOrgId } from './localStorgeOperations';
import { STAKE_HOLDER_URL, STAKEHOLDER_SUBROUTE } from '../../config/urlDataConstants';
import constants from './constants';
import { encryptJson } from './urlDataStore';

export const getIndexRoute = (pathName = window.location.pathname) => {
  let routeItems = pathName.split("/");
  return routeItems[routeItems.length - 1];
};

export const getCurrentPath = getIndexRoute;

export const getOrgIdFromUrl = (currentPath) => {
  const defaultPath = '/home/:org_id/'
  let path = matchPath(window.location.pathname, {
    path: currentPath || defaultPath
  })
  if (!path || !path.params) {
    path = matchPath(window.location.pathname, {
      path: '/admin/home/organizations/:org_id/'
    })
  }
  const params = path && path.params
  return params ? params.org_id : undefined
}
export const getTabIdFromUrl = (currentPath) => {
  const defaultPath = '/home/:org_id/'
  let path = matchPath(window.location.pathname, {
    path: currentPath || defaultPath
  })
  if (!path || !path.params) {
    path = matchPath(window.location.pathname, {
      path: '/admin/home/organizations/:org_id/'
    })
  }
  const params = path && path.params
  return params ? params.org_id : undefined
}

export const getRedirectionPathToStakeholder = () => {
  let orgId = getOrgId()
  let hostName = window.location.hostname
  let redirectionUrl = ""

  if (hostName === "app.culturebie.com" || hostName === "www.app.culturebie.com") {
    redirectionUrl = STAKE_HOLDER_URL.PRODUCTION
  }
  else if (hostName === "qa.culturebie.com" || hostName === "www.qa.culturebie.com") {
    redirectionUrl = STAKE_HOLDER_URL.STAGING
  }
  else if (hostName === "dev.culturebie.com" || hostName === "www.dev.culturebie.com") {
    redirectionUrl = STAKE_HOLDER_URL.DEVELOPMENT
  }
  else {
    //This not be depployed testing purspose
    redirectionUrl = STAKE_HOLDER_URL.LOCAL
  }

  redirectionUrl = redirectionUrl + STAKEHOLDER_SUBROUTE.ADMIN_SETUP + orgId
  return { redirectionUrl }
}

export const getTokenForRedirection = () => {
  let token = GetLocalStorage(constants.local.idToken);
  let encryptedDetails = encryptJson({ token: token })
  return { token: encryptedDetails }

}

export const getOriginNameForConfirming = () => {
  let hostName = window.location.hostname
  let origin = ""
  if (hostName === "app.culturebie.com" || hostName === "www.app.culturebie.com") {
    origin = STAKE_HOLDER_URL.PRODUCTION
  }
  else if (hostName === "qa.culturebie.com" || hostName === "www.qa.culturebie.com") {
    origin = STAKE_HOLDER_URL.STAGING
  }
  else if (hostName === "dev.culturebie.com" || hostName === "www.dev.culturebie.com") {
    origin = STAKE_HOLDER_URL.DEVELOPMENT
  }
  else {
    //This not be depployed testing purspose
    origin = STAKE_HOLDER_URL.LOCAL
  }

  return origin
}